import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiFolder, FiArrowRight } = FiIcons;

export default function HomePage() {
  return (
    <div className="home-page">
      <section className="start-card">
        <span className="eyebrow">Field-ready reporting</span>
        <h1>Capture today's fishing while it's fresh.</h1>
        <p>Speak naturally, review the details, and leave with an accurate report you control.</p>

        <div className="start-actions">
          <Link to="/new" className="primary-button large">
            <SafeIcon icon={FiPlus} />
            New Fishing Report
          </Link>
          <Link to="/reports" className="secondary-button large">
            <SafeIcon icon={FiFolder} />
            My Reports
            <SafeIcon icon={FiArrowRight} />
          </Link>
        </div>
      </section>
    </div>
  );
}